import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#a)\"><path fill=\"#D80027\" d=\"m7.828 10.957 1.044 12.63c.998.269 2.047.413 3.13.413 6.627 0 12-5.372 12-12z\"></path><path fill=\"#FFDA44\" d=\"M7.828 12 8.872.414A12 12 0 0 1 12.002 0c6.627 0 12 5.373 12 12z\"></path><path fill=\"#6DA544\" d=\"M0 12c0 5.544 3.76 10.21 8.87 11.586V.413C3.76 1.79 0 6.455 0 12\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"></path></clipPath></defs>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }